import React from 'react';
import '../../less/download-block.less';
import mobile_app_main_img from "../../img/mobile_app_main_img.png";
import mobile_app_main_img_mob from "../../img/mobile_app_main_img_mob.png";
import phone_img_1 from "../img/new-phone-img-1.png";
import phone_img_2 from "../img/new-phone-img-2.png";
import { AppGallery, downloadA24, Itunes } from '../../../../services/urls/urls';

export default function tmp() {
    const { page, img, title, desc, text, isNew, qrImg } = this.props;
    const isMobile = this.isViewportMobile();
    const isTablet = this.isViewportTablet();
    const oldDesign = <div className={`main-content-wrapper mob-app  mob-app-${page}`}>
          <div className="block-wrapper">
              <div className="left-side">
                  <div className={`main-info-block ${page}-info`}>
                      <h2 className="main-info-block-title" dangerouslySetInnerHTML={{ __html: title ? this.l10n(title) : this.l10n("CARDS_A24") }} />
                      {desc ? <p className={`main-info-block-desc`} dangerouslySetInnerHTML={{ __html: this.l10n(desc) }} /> :
                        <p className="main-info-block-notice" dangerouslySetInnerHTML={{ __html: this.l10n("CARDS_ORDER_CARD_REMOTELY") }} />}
                  </div>
                  {isMobile || isTablet ?
                    (<div className="download-block">
                        <a href={Itunes} target="_blank" className="download-block-img apple"></a>
                        <a href={downloadA24} target="_blank" className="download-block-img google"></a>
                        <a href={AppGallery} target="_blank" className="download-block-img app-gallery"></a>
                    </div>)
                    :(
                      <div className="qr-block">
                          <div className="qr-block-img" style={qrImg ? { background: `url(${qrImg}) no-repeat center/contain` } : undefined}></div>
                          <div className="qr-block-desc" dangerouslySetInnerHTML={{ __html: text ? this.l10n(text) : this.l10n("CARDS_QR_TEXT") }}></div>
                      </div>
                    )}

              </div>
              <div className="right-side">
                  <div className="right-side-img-wrapper">
                      <img alt="mobile_app_img" src={ img ? img : isMobile ? mobile_app_main_img_mob : mobile_app_main_img} className='img-card'></img>
                  </div>
              </div>
          </div>
      </div>;
    const newDesign = <div className='mob-app-wrapper'>
        <div className="title" dangerouslySetInnerHTML={{ __html: this.l10n(`MAIN_PAGE_DOWNLOAD_APP_TITLE${isMobile ? '_MOB' : ''}`) }}/>
        <div className="text" dangerouslySetInnerHTML={{ __html: this.l10n(`MAIN_PAGE_DOWNLOAD_APP_TEXT${isMobile ? '_MOB' : ''}`) }}/>
        {isMobile ? (<div className="download-block">
            <a href={Itunes} target="_blank" className="download-block-img apple"/>
            <a href={downloadA24} target="_blank" className="download-block-img google"/>
            <a href={AppGallery} target="_blank" className="download-block-img app-gallery"/>
        </div>) : <a className='black-btn' href={downloadA24}>{this.l10n('MAIN_PAGE_DOWNLOAD_APP_BTN')}</a>}
        <img alt="mobile_app_img_1" src={phone_img_1} className="img-card-1"/>
    </div>;

    return (
      <>{isNew ? newDesign : oldDesign}</>
    );
}
